const SESSION_KEY = 'auth_session';

export function getStoredSession() {
  const raw = localStorage.getItem(SESSION_KEY);

  if (!raw) {
    localStorage.removeItem('token');
    return null;
  }

  try {
    const parsed = JSON.parse(raw);
    return parsed?.user ? { user: parsed.user } : null;
  } catch (_error) {
    localStorage.removeItem(SESSION_KEY);
    localStorage.removeItem('token');
    return null;
  }
}

export function setStoredSession(session) {
  localStorage.setItem(SESSION_KEY, JSON.stringify({ user: session?.user || null }));
  localStorage.removeItem('token');
}

export function clearStoredSession() {
  localStorage.removeItem(SESSION_KEY);
  localStorage.removeItem('token');
}
